import { createContext, useEffect, useMemo, useContext, useCallback } from "react";
// import { useLocalStorage } from "./LocalStorage";
import { useLocalStorage } from '@uidotdev/usehooks'
import { triggerGTM } from "../google_tag/gtm";

export const CartContext = createContext();


export const CartProvider = ({ children }) => {
    const [cart, setCart] = useLocalStorage('cart', {});


    const addToCart = (course, quantity) => {
        //console.log(course);
        //console.log(quantity);
        triggerGTM('add_to_cart', 'cart_button', {'product_name': course.name, 'product_price': course.price, 'product_instructor': course.instructor_name, 'product_tf': course.duration});
        setCart({ ...cart, [course.id]: { course: course, quantity: quantity || cart[course.id]?.quantity || 1 } });
    }

    const removeFromCart = (courseId) => {
        const newCart = { ...cart };
        delete newCart[courseId];
        setCart(newCart);
    }

    const clearCart = () => {
        setCart({});
    }

    const getCart = () => {
        return cart;
    }
    const setCourseQuantity = (course, quantity) => {
        setCart({ ...cart, [course.id]: { course: course, quantity: quantity } });
    }

    const values = useMemo(() => ({
        cart,
        addToCart,
        removeFromCart,
        clearCart,
        getCart,
        setCourseQuantity
    }), [cart]);


    return (
        <CartContext.Provider value={values}>
            {children}
        </CartContext.Provider>
    )
}

export const useCart = () => {
    return useContext(CartContext);
}